import { useState } from "react";
import { AssistantAllButtonTypes, CodeFile } from "utils/interfaces";
import { MinecraftEnvironmentContext } from "components/utils/Contexts";
import MinecraftVideoPreviewHeader from "./MinecraftVideoPreviewHeader";

interface MinecraftVideoPreviewEnvironmentProps {
  name: string;
  video: string;
  pdf: string;
  AIAssistant: {
    name: string;
    img: string;
    greeting: string;
    intro: string;
  };
  fileState: CodeFile[];
}

// Parameters
const HEADER_HEIGHT = 123; //px

const MinecraftVideoPreview: React.FC<
  MinecraftVideoPreviewEnvironmentProps
> = ({ name, video, pdf, AIAssistant, fileState }) => {
  // States definition
  const [activeItem, setActiveItem] = useState<"editor" | "assistant">(
    "editor",
  ); // to change between editor and assistant views
  const [assistantPopupState, setAssistantPopupState] = useState<
    "closed" | "popup" | "popupNoCode" | "expanded" | "fullscreen"
  >("closed");
  const [assistantPopupClickedButton, setAssistantPopupClickedButton] =
    useState<AssistantAllButtonTypes>(undefined);

  return (
    <MinecraftEnvironmentContext.Provider value={{ HEADER_HEIGHT }}>
      <div className={`flex-grow relative`}>
        <div className="h-screen overflow-hidden">
          <MinecraftVideoPreviewHeader
            name={name}
            video={video}
            AIAssistant={AIAssistant}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            showAssistant={false}
            assistantPopupState={assistantPopupState}
            setAssistantPopupState={setAssistantPopupState}
            assistantPopupClickedButton={assistantPopupClickedButton}
            setAssistantPopupClickedButton={setAssistantPopupClickedButton}
            codeFiles={fileState}
          />
        </div>
      </div>
    </MinecraftEnvironmentContext.Provider>
  );
};

export default MinecraftVideoPreview;
